import { styled } from "@health-zelas/delta"

export const Header = styled('div', {
  display: 'flex',
  alignItems: 'center',
  padding: '0 24px',
  backgroundColor: '$neutralUltralight',
  height: '56px',
  marginBottom: '$xxs',
  '@md': {
    marginBottom: '$sm',
    padding: '0 150px'
  },
  'img': {
    maxWidth: '72px',
    '@md': {
      maxWidth: '98px'
    }
  }
})
